import {UserApi} from "../../apis";
import {useContext, useEffect, useState} from "react";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import {FaTimes, FaUsers} from "react-icons/fa";
import {useLocation, useNavigate} from "react-router";
import ImgExemplo from "../../assets/img/no-image.png";
import {Paginacao, UserEditor} from "../../components";

export const User = () => {
  const {user} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const [userList, setUserList] = useState(null);
  const [carregado, setCarregado] = useState(false);
  const navigate = useNavigate();
  const [modalImportar, setModalImportar] = useState(false);
  const {setLoading} = useContext(LoadingContext);
  const [pagina, setPagina] = useState(1);
  const [paginacaoInfo, setPaginacaoInfo] = useState(null);
  const location = useLocation();

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const load = async () => {
    setLoading(true);
    let search = null;
    let resultadoGetUsers;
    try {
      if (typeof location.state.search !== 'undefined') {
        search = (location.state.search);
      }
    } catch (e) {}
    try {
      if (search !== null) {
        resultadoGetUsers = await UserApi.getAllUserSearch(user.uuid, pagina, search);
      } else {
        resultadoGetUsers = await UserApi.getAllUser(user.uuid, pagina);
      }

      if (!resultadoGetUsers.error) {
        setUserList(resultadoGetUsers.data);
        setPaginacaoInfo(resultadoGetUsers.paginacao);
        setLoading(false);
      } else {
        AddToast({texto:resultadoGetUsers.error, tipo: "erro"});
        setLoading(false);
      }
    } catch (e) {
      AddToast({texto:e, tipo: "erro"});
      setLoading(false);
    }
  }

  useEffect(() => {load()}, [pagina]);

  if (!carregado) {
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Usuários',
        icone: <FaUsers size={30}/>
      }
    );
    load();
    setCarregado(true);
  }

  const toggleImportar = () => {
    setModalImportar(!modalImportar);
  }

  return (
    <div className="user">
      {userList &&
        <div className="painel-itens">
          <div className="botoes">
            <div className="btn btn-enviar"
                 onClick={() => navigate('/portalcolaborador/user/edit', {state: {uuid: 0}})}>
              Novo usuário
            </div>
            {/*<div className="btn btn-primary" onClick={toggleImportar}>*/}
            {/*  Importar usuários*/}
            {/*</div>*/}
          </div>
          {userList.length > 0 && userList.map((item) => (
            <UserEditor key={item.uuid} item={item} update={load}/>
          ))}
          <Paginacao pagina={pagina} setPagina={setPagina} info={paginacaoInfo}/>
        </div>
      }

      {modalImportar &&
        <div className="tela-modal-arquivo">
          <div className="modal-arquivo">
            <div className="btn-close-modal" onClick={toggleImportar}>
              <FaTimes/>
            </div>
            <h3>Importação de usuários</h3>
            <div className="informacoes">
              <h4>Para a importação a tabela deve estar no seguinte formato:</h4>
              <img src={ImgExemplo} alt="Exemplo de tabela"/>
              <div className="btn btn-primary">
                <span>Selecionar arquivo...</span>
              </div>
              <div className="btn btn-enviar">
                <span>Importar</span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}